/*****************************************************************************************
 * 설명 : AGGrid 저장하기 버튼
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useCallback, useMemo } from 'react';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const BtnAgGridSave = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const disabled = useMemo(() => {
    return props?.disabled ? props?.disabled : false;
  }, [props]);

  const clickHandler = useCallback(() => {
    if( props?.click ) {
      props?.click();
    };
  }, [props]);

  const setInitGrid = useCallback(() => {
    if( props?.init ) {
      props.init();
    };
  }, [props]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <>
      <Tooltip title="그리드 컬럼 변경정보 저장" placement="top">
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          className="mr5 btn-grid-save"
          disabled={disabled}
          onClick={clickHandler}
        >
          <span className="material-icons md-24">grid_on</span>
        </Button>
      </Tooltip>

      <Tooltip title="그리드 컬럼 초기화" placement="top">
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          className="mr5 btn-grid-save"
          disabled={disabled}
          onClick={setInitGrid}
        >
          <span className="material-icons md-24">grid_off</span>
        </Button>
      </Tooltip>
    </>
  )
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default BtnAgGridSave;
